import React from 'react';
import Routes from './routes';
import './styles/fonts.css'

const App = () => <Routes />;

export default App;

